import { useLocation } from '@tanstack/react-router';
import { useMemo } from 'react';

/**
 * @deprecated Use Tanstack Router's `useSearch` instead.
 */
export default function useQueryParams() {
  const { search } = useLocation();

  const searchParams = useMemo(() => {
    // @ts-ignore
    const urlSearchParams = new URLSearchParams(search);
    return Object.fromEntries(urlSearchParams.entries());
  }, [search]);

  return { searchParams };
}
